<cs-header>
  <cs-header-title>
    {{ LL.training.trainingProgram.muscleVolume() }}
    <help-icon name="info" helpId="@help:references.training-volume"></help-icon>
  </cs-header-title>
  @if (reoptimizeData && !hasReoptimized) {
    <cs-button header-right secondary small icon="magic-wand" (click)="handleReoptimizeVolume()">
      {{ LL.common.buttons.optimize() }}
    </cs-button>
  }
</cs-header>

<cs-content>
  <cs-muscle-volume [lowerBodyMuscles]="lowerBodyMuscles" [upperBodyMuscles]="upperBodyMuscles"
    [beforeVolumes]="beforeVolumes">
  </cs-muscle-volume>

  <!-- #3790: exercises the calculator could not attribute to any muscle. Surface them so the
       totals are not silently wrong. #4737 split them into two groups, because only the first
       kind is something the user can do anything about — and offering a tap on the second kind
       opened a page that could not load the exercise and hung on its spinner for ever.
       Each group's explanation lives in a tooltip beside its title rather than as a paragraph:
       the screen is a dense table of numbers, and two paragraphs of prose in the middle of it
       pushed the rows apart and buried them. The title says which group it is; the tooltip
       says why. Both groups use the cs-item-group [group-title] slot rather than its [title]
       input, because that slot exists for a heading with something beside it — the input
       renders a bare label the tooltip could not sit next to. -->

  <!-- the user's own exercises: tapping opens the edit page, where setting
       "Most Similar Exercise" makes the exercise join the totals -->
  @if (uncountedFixableExercises.length > 0) {
    <cs-item-group small>
      <div class="uncounted-title" group-title>
        <cs-label class="group-title">{{ LL.training.trainingProgram.notCountedTitle() }}</cs-label>
        <cs-tooltip iconType="info" [text]="LL.training.trainingProgram.notCountedExplanation()"></cs-tooltip>
      </div>
      <cs-table style="--table-columns: 1fr auto;">
        @for (item of uncountedFixableExercises; track item.subSlotId) {
          <cs-table-row clickable (rowClick)="openUncountedExercise(item)">
            <cs-table-cell>{{ item.name }}</cs-table-cell>
            <cs-table-cell align="right">
              <cs-icon name="arrow-dropright"></cs-icon>
            </cs-table-cell>
          </cs-table-row>
        }
      </cs-table>
    </cs-item-group>
  }

  <!-- built-in exercises for a body area the program does not measure. Deliberately NOT
       tappable: there is no page that could help, since "Most Similar Exercise" exists only
       on the user's own exercises. Adding a tap back here re-opens #4737. These rows need no
       "inert" styling of their own — every muscle row on this page is a plain table row too,
       so plainness reads as ordinary data rather than as something broken. -->
  @if (uncountedUntrackedExercises.length > 0) {
    <cs-item-group small>
      <div class="uncounted-title" group-title>
        <cs-label class="group-title">{{ LL.training.trainingProgram.notCountedUntrackedTitle() }}</cs-label>
        <cs-tooltip iconType="info" [text]="LL.training.trainingProgram.notCountedUntrackedExplanation()"></cs-tooltip>
      </div>
      <cs-table style="--table-columns: 1fr;">
        @for (item of uncountedUntrackedExercises; track item.subSlotId) {
          <cs-table-row>
            <cs-table-cell>{{ item.name }}</cs-table-cell>
          </cs-table-row>
        }
      </cs-table>
    </cs-item-group>
  }

</cs-content>

@if (reoptimizeData?.mode === 'save' && hasChanges) {
  <cs-page-action-buttons>
    <cs-button primary medium (click)="handleSave()" [label]="LL.common.buttons.save()"></cs-button>
  </cs-page-action-buttons>
}
